import PhoneConfirmation from './PhoneConfirmation';

export default PhoneConfirmation;
